module.exports = __webpack_public_path__ + "static/media/how-sharing-works-image.dc96c071.png";